<img *ngIf="kind === 'info'" class="illustration" [src]="imageUrl | widgetResourceUrl" alt="" />
<p-icon *ngIf="kind === 'error'" name="alert-triangle" size="lg" color="supportive-failed"></p-icon>
<div class="empty-state-body">
    <p class="title">{{ title }}</p>
    <p *ngIf="message" class="message">{{ message }}</p>
</div>
